import { useRef, useState } from 'react';
import Webcam from 'react-webcam';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  IconButton,
} from '@mui/material';
import { CameraAlt, FlipCameraAndroid } from '@mui/icons-material';

const PhotoCapture = ({ open, onClose, onCapture }) => {
  const webcamRef = useRef(null);
  const [facingMode, setFacingMode] = useState('user');

  const capture = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    if (imageSrc) {
      // Convertir base64 a Blob
      fetch(imageSrc)
        .then(res => res.blob())
        .then(blob => {
          const file = new File([blob], 'photo.jpg', { type: 'image/jpeg' });
          onCapture(file);
          onClose();
        });
    }
  };

  const toggleCamera = () => {
    setFacingMode(prev => (prev === 'user' ? 'environment' : 'user'));
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Capturar Foto</DialogTitle>
      <DialogContent>
        <Box sx={{ position: 'relative', width: '100%', paddingTop: '75%' }}>
          <Webcam
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            videoConstraints={{ facingMode }}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
          <IconButton
            onClick={toggleCamera}
            sx={{
              position: 'absolute',
              top: 10,
              right: 10,
              backgroundColor: 'rgba(255, 255, 255, 0.7)',
            }}
          >
            <FlipCameraAndroid />
          </IconButton>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={capture} variant="contained" startIcon={<CameraAlt />}>
          Capturar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PhotoCapture;
